import React, { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { PLANN3R_COLOR } from '../../../../constants'
import { Plann3rStore } from '../../../../store/types'

import { IProps } from './types'

const LocationField: FC<IProps> = ({
  field,
  colors,
  locations,
  value,
  required,
  onLocationChange,
}) => {
  const [selectedTab, setselectedTab] = useState('')

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.link.almostdone,
  )

  if (selectedTab === '' && locations && locations !== undefined && onLocationChange) {
    if (locations.my_office?.enabled) {
      onLocationChange(locations.my_office.locations[0], false)
      setselectedTab('MY_OFFICE')
    } else if (locations.call?.enabled) {
      onLocationChange(locations.call.options[0].type + ' - ' + locations.call.options[0].value, true)
      setselectedTab('CALL')
    } else if (locations.their_office?.enabled) {
      onLocationChange('', false)
      setselectedTab('THEIR_OFFICE')
    }
  }

  const fieldStyle = {
    color: colors?.primary ? colors.primary : PLANN3R_COLOR,
  }

  const normal_tab_styling = {
    borderColor: colors?.secondary,
    backgroundColor: 'white',
    color: colors?.secondary,
  }

  const selected_tab_styling = {
    borderColor: colors?.secondary,
    backgroundColor: colors?.secondary,
    color: 'white',
  }

  const normal_item = {
    color: PLANN3R_COLOR,
  }

  const selected_item = {
    color: colors?.secondary,
  }

  if (!locations || locations === undefined) return <div />

  return (
    <div key={field.id} className="page_field">
      {(locations.my_office?.enabled || locations.their_office?.enabled) && (
        <label style={fieldStyle}>
          Location
          {required && <sup>*</sup>}
        </label>
      )}
      <div className="location_field">
        <div className="location_tab">
          {((locations.my_office?.enabled && locations.their_office?.enabled) ||
            (locations.my_office?.enabled && locations.call?.enabled) ||
            (locations.their_office?.enabled && locations.call?.enabled)) && (
            <span
              className={selectedTab === 'MY_OFFICE' ? 'selected' : ''}
              style={
                selectedTab === 'MY_OFFICE' ? selected_tab_styling : normal_tab_styling
              }
              onClick={() => {
                if (locations.my_office?.locations && locations.my_office.locations.length > 0) {
                  if(onLocationChange) onLocationChange(locations.my_office?.locations[0], false)
                  setselectedTab('MY_OFFICE')
                }
              }}
              role="presentation"
            >
              {strings.my_office}
            </span>
          )}
          {locations.call?.enabled && (
            <span
              className={selectedTab === 'CALL' ? 'selected' : ''}
              style={selectedTab === 'CALL' ? selected_tab_styling : normal_tab_styling}
              onClick={() => {
                if(onLocationChange) onLocationChange(locations.call?.options[0].type +
                      ' - ' +
                      locations.call?.options[0].value, true)
                setselectedTab('CALL')
              }}
              role="presentation"
            >
              {strings.call}
            </span>
          )}
          {locations.their_office?.enabled && (
            <span
              className={
                selectedTab === 'THEIR_OFFICE' ? 'selected' : ''
              }
              style={
                selectedTab === 'THEIR_OFFICE'
                  ? selected_tab_styling
                  : normal_tab_styling
              }
              onClick={() => {
                if(onLocationChange) onLocationChange('', false)
                setselectedTab('THEIR_OFFICE')
              }}
              role="presentation"
            >
              {strings.your_office}
            </span>
          )}
        </div>
        <div className="location_content">
          {selectedTab === 'MY_OFFICE' && (
            <ul>
              {locations.my_office?.locations.map(
                (location: string, index: number) => {
                  const selected = value === location
                  return (
                    <li
                      className={selected ? 'selected' : ''}
                      style={selected ? selected_item : normal_item}
                      key={index}
                      onClick={() => {
                        if(onLocationChange) onLocationChange(location, false)
                      }}
                      role="presentation"
                    >
                      <i className="fa fa-map-marker" />
                      {location}
                    </li>
                  )
                },
              )}
            </ul>
          )}
          {selectedTab === 'CALL' && (
            <ul>
              {locations.call?.options.map((option: { type: string; value: string }) => {
                const selected =
                  value === option.type + ' - ' + option.value
                return (
                  <li
                    className={selected ? 'selected' : ''}
                    style={selected ? selected_item : normal_item}
                    key={option.type}
                    onClick={() => {
                      if(onLocationChange) onLocationChange(option.type + ' - ' + option.value, true)
                    }}
                    role="presentation"
                  >
                    <i className="fa fa-phone" />
                    {option.type + ' - ' + option.value}
                  </li>
                )
              })}
            </ul>
          )}
          {selectedTab === 'THEIR_OFFICE' && (
            <div className="field full-width">
              <input
                type="text"
                className="input full-width"
                placeholder={strings.fill_in_address}
                value={value}
                onChange={(e) => {
                  if(onLocationChange) onLocationChange(e.target.value, false)
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default LocationField
